import React from 'react'
import {MobileDrawer, Text} from 'wix-ui-tpa/cssVars'
import {CloseButton} from '../../common/close-button'
import {LegendItem} from '../plan/legend/item'
import {PricesOverlayProps} from './interfaces'
import {classes} from './prices-overlay.st.css'

export const PricesOverlay = ({legendItems, pricesOverlayOpen, onClose, t}: PricesOverlayProps) => (
  <MobileDrawer isOpen={pricesOverlayOpen} onRequestClose={onClose}>
    <div className={classes.container}>
      <div className={classes.header}>
        <Text tagName="h2" className={classes.title}>
          {t('seatingMapModal_prices_title')}
        </Text>
        <CloseButton small className={classes.closeButton} closeButtonAsButton={false} closeModal={onClose} />
      </div>
      <div className={classes.list}>
        {legendItems.map(({color, price, name}, index) => (
          <LegendItem key={index} color={color} price={price} name={name} />
        ))}
      </div>
    </div>
  </MobileDrawer>
)
